import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./fullscorecard.css";

function Fullscorecard() {
  const [batting, setBatting] = useState([]);
  const [bowling, setBowling] = useState([]);
  const [extras, setExtras] = useState({});
  const [matchSummary, setMatchSummary] = useState({});
  const [fallOfWickets, setFallOfWickets] = useState([]);
const [team1 ,setTeam1] = useState("");
const [team2 ,setTeam2] = useState("");
  const match_id = localStorage.getItem("match_id");
  const navigate = useNavigate();
  const scoreRef = useRef();

  useEffect(() => {
    // Batting stats
    fetch(`https://nammateam.onrender.com/battinstats/${match_id}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setBatting(data.batsmen);

          // Build Fall of Wickets dynamically from out batsmen
          const fow = data.batsmen
            .filter(b => b.is_out)
            .map(b => ({
              player: b.batsman_name,
              score: `${b.runs}/${b.wicket_number || ""}`, // optional wicket_number if exists
              over: b.out_over || "",
              out_type: b.out_type || "",
              out_bowler: b.out_bowler || "",
              out_help: b.out_help || ""
            }));
          setFallOfWickets(fow);
        }
      });

    // Bowling stats
    fetch(`https://nammateam.onrender.com/bowlingstats/${match_id}`)
      .then(res => res.json())
      .then(data => { if (data.success) setBowling(data.bowlers); });

    // Extras
    fetch(`https://nammateam.onrender.com/match/extras/${match_id}`)
      .then(res => res.json())
      .then(data => { if (data.success) setExtras(data.extras); });

 fetch(`https://nammateam.onrender.com/match/${match_id}`)
      .then(res => res.json())
      .then(datas => {const batting_team =
          datas.toss_winner === datas.host_team
            ? (datas.opt_to === 'bat' ? datas.host_team : datas.visitor_team)
            : (datas.opt_to === 'bat' ? datas.visitor_team : datas.host_team);
       
if(batting_team === datas.host_team)
{
 setTeam1(datas.host_team);
 setTeam2(datas.visitor_team)
}
else
{
  setTeam2(datas.host_team);
 setTeam1(datas.visitor_team)
}

      })

    // Match summary
    fetch(`https://nammateam.onrender.com/match/summary/${match_id}`)
      .then(res => res.json())
      .then(data => {
        
           setMatchSummary(data); 


      });
  }, [match_id]);

  const downloadPDF = () => {
    if (!scoreRef.current) return;
    html2canvas(scoreRef.current, { scale: 2 }).then(canvas => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "pt", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`scorecard_match_${match_id}.pdf`);
    });
  };

  return (
    <div className="fsc-container">
      <div className="fsc-header">
        <button className="fsc-back" onClick={() => navigate("/live")}>← Back</button>
        <h2>Full Scorecard</h2>
        <button className="fsc-download" onClick={downloadPDF}>Download PDF</button>
      </div>

      <div ref={scoreRef} className="fsc-content">
        <div className="fsc-match-title">
          <h3>{team1|| "Team 1"} v/s {team2 || "Team 2"}</h3>
          <p>{matchSummary.result || ""}</p>
        </div>

        {/* Batting Table */}
        <div className="fsc-section">
          <div className="fsc-team-header">{team1 || "Team 1"} --- Batting</div>
          <table className="fsc-table">
            <thead>
              <tr>
                <th>Batsman</th><th>R</th><th>B</th><th>4s</th><th>6s</th><th>SR</th>
              </tr>
            </thead>
            <tbody>
              {batting.map((b, i) => (
                <tr key={i} className={b.is_out ? "" : "fsc-notout-row"}>
                  <td>
                    {b.batsman_name}
                    <br />
                    <small className={`fsc-status ${b.is_out ? "" : "fsc-notout"}`}>
                      {b.is_out
                        ? `${b.out_type}${b.out_bowler ? ` - Bowler: ${b.out_bowler}` : ""}${b.out_help ? ` Help: ${b.out_help}` : ""}`
                        : 'not out'}
                    </small>
                  </td>
                  <td>{b.runs}</td>
                  <td>{b.balls_faced}</td>
                  <td>{b.fours}</td>
                  <td>{b.sixes}</td>
                  <td>{b.strike_rate}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="fsc-extras">
            Extras: ({extras.total || 0}) {`B ${extras.byes || 0}, LB ${extras.leg_byes || 0}, WD ${extras.wides || 0}, NB ${extras.no_balls || 0}, P ${extras.penalty || 0}`}
          </div>
          <div className="fsc-total">
            Total: {matchSummary.total_runs || 0}-{matchSummary.total_wickets || 0} ({matchSummary.overs || "20.0"})
          </div>
        </div>

        {/* Bowling Table */}
        <div className="fsc-section">
          <div className="fsc-team-header">{team2 } --- Bowling</div>
          <table className="fsc-table">
            <thead><tr><th>Bowler</th><th>O</th><th>M</th><th>R</th><th>W</th><th>ER</th></tr></thead>
            <tbody>
              {bowling.map((b, i) => (
                <tr key={i}>
                  <td>{b.bowler_name}</td>
                  <td>{b.overs_bowled}</td>
                  <td>{b.maidens}</td>
                  <td>{b.runs_given}</td>
                  <td>{b.wickets}</td>
                  <td>{b.economy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Fall of Wickets Table */}
        <div className="fsc-section">
          <div className="fsc-team-header">Fall of Wickets</div>
          <table className="fsc-table">
            <thead>
              <tr><th>Batsman</th><th>Score</th><th>Over</th><th>Dismissal</th></tr>
            </thead>
            <tbody>
              {fallOfWickets.map((w, i) => (
                <tr key={i}>
                  <td>{w.player}</td>
                  <td>{w.score}</td>
                  <td>{w.over}</td>
                  <td>{w.out_type}{w.out_bowler ? ` - Bowler: ${w.out_bowler}` : ""}{w.out_help ? ` Help: ${w.out_help}` : ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
}

export default Fullscorecard;
